const periodSelector = `common.periodSelector`;

export default {
    periodSelector: {
        input: `${periodSelector}.inputNumberOfPeriods`,
        select: `${periodSelector}.selectPeriod`,
        switch: `${periodSelector}.switch`,
        template: `${periodSelector}.template`,
        openPeriod: `${periodSelector}.openPeriodSelector`,
        rollingAndFixed: `${periodSelector}.rollingAndFixedFieldGroup`,
    },
};
